export default __webpack_public_path__ + "navigation-examples-route-init-960-b7327342d715dce41129b059cb4c959b.webp";